var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 2.68 2.684 0 6 0H54C57.316 0 60 2.68 60 6V41.976C60 45.292 57.316 47.972 54 47.972H39.072L31.664 59.072C31.4814 59.3459 31.2339 59.5705 30.9436 59.7258C30.6534 59.8812 30.3292 59.9624 30 59.9624C29.6708 59.9624 29.3466 59.8812 29.0564 59.7258C28.7661 59.5705 28.5186 59.3459 28.336 59.072L20.932 47.972H6C2.684 47.972 0 45.292 0 41.972V6ZM28.096 34.92L43.504 17.312L40.496 14.68L27.904 29.072L21.416 22.58L18.584 25.412L28.096 34.92Z",
    fill: "#0D928C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon);
export default __webpack_public_path__ + "static/media/infoicon.2d58e8070e0cb1cb9b3ab9919ac269a5.svg";
export { ForwardRef as ReactComponent };